import { render, staticRenderFns } from "./RegWaNumber.vue?vue&type=template&id=0e8f9b4c&lang=pug"
import script from "./RegWaNumber.vue?vue&type=script&lang=js"
export * from "./RegWaNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports